import PicklistMetadata from "../PicklistMetadata";

class ProjectPlanNamePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "ProjectPlanName"
        this.bounded = true;
        this.enterpriseComponent = "ProjectPlan";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.static = false;
        this.typeField = null;
        this.typeValue = "Name";
        this.typeValue2 = null;
        this.visibilityType = null;
    }
}

export default ProjectPlanNamePicklistMetadata;
